import { render, staticRenderFns } from "./EditQuestionHeader.vue?vue&type=template&id=db3a8a0c&scoped=true&"
import script from "./EditQuestionHeader.vue?vue&type=script&lang=ts&"
export * from "./EditQuestionHeader.vue?vue&type=script&lang=ts&"
import style0 from "./EditQuestionHeader.vue?vue&type=style&index=0&id=db3a8a0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3a8a0c",
  null
  
)

export default component.exports